import { defineStore } from 'pinia'
import { getUserInfo } from '../api/user'

// 用户信息存储
export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    permissions: []
  }),
  
  getters: {
    isLoggedIn: (state) => !!state.token || Object.keys(state.userInfo).length > 0
  },
  
  actions: {
    setToken(token) {
      this.token = token
      localStorage.setItem('token', token)
    },
    
    setUserInfo(userInfo) {
      this.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    
    async getUserInfo() {
      try {
        const response = await getUserInfo()
        if (response.success) {
          this.setUserInfo(response.data)
        }
        return response
      } catch (error) {
        console.error('获取用户信息失败:', error)
        return { success: false, message: '获取用户信息失败' }
      }
    },
    
    logout() {
      this.token = ''
      this.userInfo = {}
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  }
})

// 应用设置存储
export const useSettingsStore = defineStore('settings', {
  state: () => ({
    collapsed: false,
    theme: 'light',
    // 布局模式: 'horizontal' 水平布局（顶部菜单），'vertical' 垂直布局（左侧菜单）
    layoutMode: localStorage.getItem('layoutMode') || 'horizontal'
  }),
  
  getters: {
    isHorizontalLayout: (state) => state.layoutMode === 'horizontal',
    isVerticalLayout: (state) => state.layoutMode === 'vertical'
  },
  
  actions: {
    toggleSidebar() {
      this.collapsed = !this.collapsed
    },
    
    setCollapsed(status) {
      this.collapsed = status
    },
    
    setLayoutMode(mode) {
      this.layoutMode = mode
      localStorage.setItem('layoutMode', mode)
    },
    
    toggleLayoutMode() {
      const newMode = this.layoutMode === 'horizontal' ? 'vertical' : 'horizontal'
      this.setLayoutMode(newMode)
    }
  }
}) 